<template>
  <v-row
    no-gutters
    class="image-text-banner-container"
    :class="reversed === true ? 'reverse' : 'normal'"
  >
    <v-col
      cols="12"
      md="6"
      class="left-section-image-text-banner"
      :class="{ isMobile: isMobile }"
    >
      <v-img class="tile-img" :src="imageUrl" cover />
    </v-col>
    <v-col cols="12" md="6" class="right-section-image-text-banner">
      <div class="right-section-text">
        <div v-if="date" class="date">{{ date }}</div>
        <div v-if="category" class="category">{{ category }}</div>
        <h1>
          <strong style="font-weight: 500" v-html="title"> </strong>
        </h1>
        <p v-html="paragraphOne"></p>
        <p class="bolded-paragraph" v-if="boldedParagraph">
          {{ boldedParagraph }}
        </p>
        <div v-if="buttonText" class="parent-button-container">
          <div
            class="button-container"
            :class="{ 'no-bottom-margin': !bottomMargin }"
          >
            <div class="fit-content">
              <GradientButton
                @gradientButtonClicked="gradientButtonClicked"
                :title="buttonText"
                :callout="'right'"
              />
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import InfoTile from "./InfoTile.vue";

export default {
  name: "ImageTextBanner",
  components: {
    InfoTile,
  },
  props: {
    date: {
      required: false,
      default: "",
      type: String,
    },
    title: {
      required: true,
      default: "",
      type: String,
    },
    paragraphOne: {
      required: true,
      default: "",
      type: String,
    },
    imageUrl: {
      required: true,
      default: "",
      type: String,
    },
    buttonText: {
      required: false,
      default: null,
      type: String,
    },
    reversed: {
      required: true,
      default: false,
      type: Boolean,
    },
    boldedParagraph: {
      required: false,
      default: "",
      type: String,
    },
    category: {
      required: false,
      default: "",
      type: String,
    },
    bottomMargin: {
      required: false,
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    gradientButtonClicked() {
      this.$emit("gradientButtonClicked");
    },
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
  },
};
</script>

<style scoped lang="scss">
.image-text-banner-container {
  h1 {
    font-size: 28px;
    font-weight: 300;
    line-height: 34px;
    letter-spacing: -0.0025em;
    margin-bottom: 12px;
  }
  p {
    color: #282828;
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
    margin-bottom: 12px;
  }

  .bolded-paragraph {
    padding-top: 24px;
    color: #282828;
    font-weight: 600;
  }
  h3 {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #282828;
    margin-bottom: 24px;
  }

  .parent-button-container {
    padding-left: 0 !important;

    .button-container {
      padding-left: 0 !important;
      width: fit-content;

      &.no-bottom-margin {
        margin-bottom: 0 !important;
      }

      .fit-content {
        padding-left: 0 !important;

        .gradient-button {
          padding-left: 0 !important;
        }
      }
    }
  }
}
.left-section-image-text-banner {
  max-width: 528px;
  min-width: 528px;
  max-height: 383px;
  min-height: 383px;
  padding: 0 !important;
}

.image-text-banner-container.normal {
  .left-section-image-text-banner {
    display: flex;
    justify-content: flex-end;
    padding-right: 16px;
    padding-left: 16px;
  }
  .right-section-image-text-banner {
    display: flex;
    justify-content: flex-start;
    padding-left: 80px;
    padding-top: 48px;

    div {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding-right: 20px;
    }
  }
}

.image-text-banner-container.reverse {
  flex-direction: row-reverse;
  .left-section-image-text-banner {
    display: flex;
    justify-content: flex-start;
    padding-left: 16px;
    padding-right: 16px;
  }
  .right-section-image-text-banner {
    display: flex;
    justify-content: flex-end;
    padding-right: 80px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 20px;
    }
  }
}

.date,
.category {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.4px;
  text-align: left;
}
.category {
  margin-bottom: 20px;
}

.isMobile {
  ::v-deep {
    .v-image {
      max-width: 95dvw;
    }
  }
}

@media only screen and (min-width: 0px) and (max-width: 1111px) {
  .left-section-image-text-banner,
  .image-text-banner-container {
    justify-content: center !important;
  }
  .right-section-image-text-banner {
    padding-left: 0 !important;
  }
  .image-text-banner-container {
    h1 {
      margin-top: 24px;
    }
  }
  .right-section-image-text-banner {
    padding-top: 40px !important;
    justify-content: center !important;
    padding-right: 0 !important;
  }
  h1 {
    margin-top: 0 !important;
  }
  .right-section-text {
    padding-right: 0 !important;
    padding-left: 0 !important;
    max-width: 528px;
  }
  .date {
    margin-top: 20px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 600px) {
  .date {
    margin-top: 20px;
  }
  .right-section-text {
    padding-right: 0 !important;
    padding-left: 0 !important;
    max-width: 95dvw;
  }
}
</style>
